// removed by extract-text-webpack-plugin
module.exports = {"message":"RedirectedMessage-style__message__2b72a5b0"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/RedirectedMessage/RedirectedMessage-style.scss
// module id = 3513
// module chunks = 4